import React, {useState} from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import moment from 'moment'
import {withI18n} from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import {InputField, DateInput, TimeInput, InputEditor} from '../../atoms'
import {AlertDialog, SimpleDialog} from '../../molecules'
import ActionDialog from '../action-dialog'
import * as api from '../../../api'
import {StatusType} from "../../../models";
import {useDispatch, useStore} from "react-redux";
import {CitationsOperations} from "../../../redux/citations";
import {useLocation} from "react-router";
import {getCurrentSectionKey, INTEGRATIONS, SECTION_KEYS} from "../../../config/constants";
import Switch from "@material-ui/core/Switch";

const ModalAnnouncement = ({open, handleClose, i18n, onSubmit, sms, self, isEdit = false, data = null}) => {
  const dispatch = useDispatch();
  const store = useStore();
  const currentLocation = useLocation();

  const [openPopup, setOpenPopup] = React.useState(false)
  const [isSwitchActive, setIsSwitchActive] = React.useState(false)
  const [eventName, setEventName] = React.useState('')
  const [optionalAttendees, setOptionalAttendees] = React.useState('')
  const [location, setLocation] = React.useState('')
  const [message, setMessage] = React.useState('')
  const [date, setDate] = React.useState(() => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1); // Sumar un día
    return currentDate;
  });

  const [startTime, setStartTime] = React.useState(moment().add(1, 'days').set({ hour: 8, minute: 0 }).format('HH:mm'));
  const [ endTime, setEndTime ] = React.useState(moment().add(1, 'days').set({ hour: 9, minute: 0 }).format('HH:mm'));
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [confirmationData, setConfirmationData] = useState(null)
  const [ external_id, setExternalId ] = useState(null)
  const [ citation_id, setCitationId ] = useState(null);

  const [defaultMessages, setDefaultMessages] = React.useState([])

  React.useEffect(() => {
    const fetchData = async () => {
      const result = await api.getDefaultMessages()
      setDefaultMessages(result)
    }
    fetchData();
  }, [])

  React.useEffect(() => {
    if (data && !_.isEmpty(data)) {
      if (!isEdit) {
        let filteredData = data.filter(item => ![StatusType.HIRED, StatusType.DISCARDED, StatusType.DISCARDED_PHASE_2].includes(item.estado));
        setConfirmationData(filteredData);
      } else {

        let citationData = Array.isArray(data) ? data[0] : data;
        if (citationData.hasOwnProperty('citation_date')) {
          let dateObj = new Date(citationData.citation_date);
          let startTimeValue = citationData.citation_date ? citationData.citation_date.split('T').pop().split('+').shift().substring(0, 5) : null;
          let endTimeValue = citationData.citation_end_date ? citationData.citation_end_date.split('T').pop().split('+').shift().substring(0, 5) : null;
          setDate(dateObj);
          setStartTime(startTimeValue);
          setEndTime(endTimeValue);
        }

        setEventName(getCurrentSectionKey() !== SECTION_KEYS.INBOX && citationData.hasOwnProperty('event_name') ? citationData.event_name : '');
        setOptionalAttendees(getCurrentSectionKey() !== SECTION_KEYS.INBOX && citationData.hasOwnProperty('optionalAttendees') ? citationData.optionalAttendees : '');
        setLocation(citationData.hasOwnProperty('location') ? citationData.location : '');
        setMessage(citationData.hasOwnProperty('message') ? citationData.message : '');

        let dataValues = Array.isArray(data) ? data : [data];
        let filteredData = dataValues.filter(() => {

          // if (item.candidature) {
          //   return ![StatusType.HIRED, StatusType.DISCARDED, StatusType.DISCARDED_PHASE_2].includes(item.candidature.state.id)
          // }
          return false;
        });
        setConfirmationData(filteredData);
      }
    }
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  function handleClickOpenPopup() {
    setOpenPopup(true)
  }

  const handleClosePopup = value => {
    setOpenPopup(false)

    if (value) {
      const eventName = value.event_name || ''
      const optionalAttendees = value.optionalAttendees || ''
      const location = value.location || ''
      const body = value.body || ''

      setEventName(eventName)
      setOptionalAttendees(optionalAttendees)
      setLocation(location)
      setMessage(body)
    }
  }

  const clear = () => {
    setEventName('')
    setOptionalAttendees('')
    setLocation('')
    setMessage('')
    setDate(new Date())
    setStartTime(moment().format('HH:mm'))
    setEndTime(moment().format('HH:mm'))
    setIsSwitchActive(false)
    setExternalId(null)
    setCitationId(null)
  }

  // Devuelve la petición cuando la hay: el botón (del modal o de la confirmación) mantiene el
  // spinner y el modal se cierra cuando ha ido bien. Si hay que confirmar, el modal se cierra
  // antes de abrir la confirmación, como hasta ahora
  const handleSubmit = (e, send = false) => {
    e && e.preventDefault()

    if (!send) {
      if (!isEdit) {
        let ids = _.map(confirmationData, 'id');

        if (_.isEmpty(ids)) {
          handleClose()
          return
        }

        return dispatch(CitationsOperations.getEditCitationsCounter(ids)).then(() => {
          let state = store.getState();

          if (state.citations.editCounter > 0) {
            handleClose()
            toggleConfirmationModal();
          } else {
            return submitAction();
          }
        });
      } else {

        let state = store.getState();
        let profileData = state && state.profile && state.profile.data ? state.profile.data : null;

        if (currentLocation.pathname.includes('profile') && profileData && _.isEmpty(profileData.citation)) {
          return submitAction();
        } else {
          handleClose()
          toggleConfirmationModal();
        }

      }
    } else {
      return submitAction();
    }
  }

  const toggleConfirmationModal = () => {
    if (!confirmationModal) {
      setConfirmationModal(true)
      return
    }
    setConfirmationModal(false)
  }

  const submitAction = () => {
    const citation_date = new moment(`${moment(date).format('YYYY/DD/MM')} ${startTime}`, 'YYYY/DD/MM HH:mm').format('YYYY-MM-DD HH:mm:ss');
    const citation_end_date = new moment(`${moment(date).format('YYYY/DD/MM')} ${endTime}`, 'YYYY/DD/MM HH:mm').format('YYYY-MM-DD HH:mm:ss');
    const sms_notification = sms;

    return Promise.resolve(onSubmit({
      event_name: eventName,
      optional_attendees: optionalAttendees,
      location,
      citation_date,
      citation_end_date,
      online_meeting: isSwitchActive,
      sms_notification,
      message,
      external_id,
      citation_id,
    })).then(() => {
      handleClose()
      setConfirmationModal(false);
      clear();
    })
  }

  const toggleSwitch = () => setIsSwitchActive(!isSwitchActive);

  const getCurrentIntegration = () => {
    if (self && INTEGRATIONS) {
      let currentIntegration = _.find(INTEGRATIONS, {event_type: self.event_type})
      return currentIntegration ? currentIntegration : null;
    }
    return null
  }

  return (
    <>
      <ActionDialog
        open={open}
        title={!isEdit ? i18n.modalAnnouncement.quoteCall : i18n.modalAnnouncement.editQuoteCall}
        onClose={handleClose}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={!isEdit ? i18n.modalAnnouncement.sendCitation : i18n.modalAnnouncement.updateCitation}
        disableBackdropClose
      >
        <S.Body>
          <div>
            <S.Label>{i18n.modalAnnouncement.new_event}</S.Label>
            <InputField
              fontSize="small"
              placeholder={i18n.modalAnnouncement.new_event}
              name="event_name"
              value={eventName}
              handleOnChange={value => setEventName(value)}
            />
          </div>
          {getCurrentIntegration() &&
          <div>
            <S.Label>{i18n.modalAnnouncement.invite_people}</S.Label>
            <InputField
              fontSize="small"
              placeholder={i18n.modalAnnouncement.invite_people}
              name="optionalAttendees"
              value={optionalAttendees}
              handleOnChange={value => setOptionalAttendees(value)}
            />
          </div>
          }
          <div>
            <S.Label>{i18n.modalAnnouncement.citationDate}</S.Label>
            <div className="citation-datetime">
              <div className="citation-date">
                <DateInput fontSize="small" name="date" onChange={e => setDate(e)} value={date}/>
              </div>
              <div className="time-range">
                <TimeInput fontSize="small" name="start_time" onChange={e => setStartTime(e.target.textContent)} value={startTime}/>
                <span>{i18n.modalAnnouncement.to_time}</span>
                <TimeInput fontSize="small" name="end_time" onChange={e => setEndTime(e.target.textContent)} value={endTime}/>
              </div>
            </div>
          </div>
          {getCurrentIntegration() &&
          <div>
            <S.Label>{i18n.modalAnnouncement.online_meeting}</S.Label>
            <div className="online-meeting">
              <img src={require(`../../../assets/images/${getCurrentIntegration().logo}`).default} height={20} alt={getCurrentIntegration().event_type}/>
              <Switch
                checked={isSwitchActive}
                onClick={() => {toggleSwitch()}}
                name={"online_meeting"}
                value="isSwitchActive"
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            </div>
          </div>}
          {!isSwitchActive &&
          <div>
            <S.Label>{i18n.modalAnnouncement.location}</S.Label>
            <InputField
              fontSize="small"
              placeholder={i18n.modalAnnouncement.writeLocation}
              name="location"
              value={location}
              handleOnChange={value => setLocation(value)}
            />
          </div>}
          <div>
            <S.Label>{i18n.modalAnnouncement.notes}</S.Label>
            <InputEditor
              fontSize="small"
              placeholder={i18n.modalAnnouncement.writeDetails}
              name="message"
              value={message}
              onChange={value => setMessage(value)}
            />
            <S.Link type="button" onClick={handleClickOpenPopup}>{i18n.modalAnnouncement.defaultMessages}</S.Link>
          </div>
        </S.Body>
        <SimpleDialog defaultMessages={defaultMessages} open={openPopup} onClose={handleClosePopup}/>
      </ActionDialog>
      <AlertDialog
        open={confirmationModal}
        onClose={() => setConfirmationModal(false)}
        onSuccess={(e) => handleSubmit(e, true)}
        title={i18n.process.deleteModalTitle}
        text={confirmationData && confirmationData.length > 0 ? i18n.modalAnnouncement.confirmation.description_update.replaceAll('{num}', confirmationData.length) : i18n.modalAnnouncement.confirmation.description_update_one}
      />
    </>
  )
}

ModalAnnouncement.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}

const enharce = compose(withI18n)

export default enharce(ModalAnnouncement)
